import React, { useEffect, useState } from 'react';
import { Breadcrumb, Col, Form, Row } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Graybg from '../../UI/Graybg';
import Select from '../../UI/Select/Select';
import Card from '../../UI/Card/Card';
import DatePicker from '../../Components/DatePicker/DatePicker';
import classes from './CreateDummy.module.css';
import { subDays, setHours, setMinutes, getTime } from 'date-fns';
import userService from '../../app/services/user.service'
import { toast } from 'react-toastify';
import Toast from '../../UI/Toast/Toast';
import { isEmpty } from '../../utils/custom_funtions';
import { uid } from 'react-uid';
import MultiSelectDropdown from '../../UI/MultiSelectDropdown/MultiSelectDropdown';
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import SecBTN from '../../UI/SecBTN';

const CreateDummy = () => {
  const {state} = useLocation();
  const user_id = JSON.parse(localStorage.getItem("user"))?.data?.user?.user_id;
  console.log("Creating dummy", state)
  const [myAssignData, setMyAssignData] = useState([])
  const [paperData, setPaperData] = useState([])
  const [qidList, setQidList] = useState([])
  const [selectedQid, setSelectedQid] = useState([])
  const [selectedfaculty, setSelectedFaculty] = useState('')
  const [facultyList, setFacultyList] = useState([])
  const [dateRange, setDateRange] = useState([subDays (new Date(), 6), new Date()]);
  const [startDate, endDate] = dateRange;
  const [selectPaper, setSelectPaper] = useState('')
  const [reqData, setReqData] = useState({
    paper_id: "",
    sub_id: state.sid,
    sec_id: "",
    faculty_id: "",
    question:""
  });
  const [selectMyAssign, setSelectMyAssign] = useState('')
  // const [selectCopySec, setSelectCopySec] = useState('')
  // const [selectFaculty, setSelectFaculty] = useState('')
  const getPaperName = () => {
    const body = {
      from_date: startDate?.toLocaleString("sv-SE").slice(0,10),
      to_date: endDate?.toLocaleString("sv-SE").slice(0,10),
      sub_id: state.sid,
    };
    userService.getPaperName(body)
    .then(res => {
      console.log(res.data)
      setPaperData(res.data)
    })
    .catch(err => {
      console.error(err);
      toast.error("Data Not Found for the selected date range")
    })
  }
  const getMatrixdata = () =>
        userService
          .getPaperMatrix(state)
          .then((res) => {
            const arr = [];
            for (let key in res.data) {
              arr.push(res.data[key]);
            }
            setMyAssignData(arr)
            console.log("MY arr ",arr[1])
        
          })
          .catch((err) => {
            console.log(err);
          });
  useEffect(() => {
    getMatrixdata();
  },[])
  useEffect(() => {
    if(dateRange[0]!== null && dateRange[1] !== null){
      getPaperName();
    }
  },[dateRange])

  useEffect(() => {
    if(!isEmpty(reqData.sec_id) && !isEmpty(reqData.faculty_id)){
      console.log(reqData)
      userService.getQidData(reqData)
      .then(res => {
        console.log(res.data);
        setQidList(res.data)
      })
      .catch(err => {
        console.log(err)
      })
    }
  },[reqData.sec_id,reqData.faculty_id])
  const onPaperSelect = e => {
    console.log(e.target.value);
    const splitedArr = e.target.value.split(',')
    setSelectPaper(e.target.value)
    setFacultyList(paperData[splitedArr[1]].faculty)
    setReqData(prev => {
      return {
        ...prev,
        sec_id:"",
        faculty_id:"",
        question:"",
        paper_id:splitedArr[0]
      }
    })

  }
  const onDragEnd = (result) => {
    const newItems = Array.from(selectedQid);
    console.log("newItems1",newItems)
    const [removed] = newItems.splice(result.source.index, 1);
    newItems.splice(result.destination.index, 0, removed);
    // setItems(newItems);
    console.log("newItems2",newItems)
    setSelectedQid(newItems);
  };
  const navigate = useNavigate();
  const createDummyPaper = () => {
    const body = {
      paper_id: state.pid,
      sub_id: reqData.sub_id,
      sec_id: reqData.sec_id,
      faculty_id: state.uid,
      // faculty_id: user_id,
      question_list: selectedQid.map((item,i) => {
        return {
          qid: item['TblPaper.qid'],
          qno: i+1,
        };
      }),
    };
    userService.createDummy(body)
    .then(res => {
      toast.success("Dummy paper successfully create.")
      navigate("/createPaper")
    })
    .catch(err => console.log(err))
  }
  return (
    <>
      <Toast />
      <div className={`section`}>
        <h4>Create Paper</h4>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/createPaper">Create Paper</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item active>Create Dummy Paper</Breadcrumb.Item>
        </Breadcrumb>
        <Card>
          <Row>
            <Col className="mb-2" lg={6} md={6} sm={12}>
              <Form.Label>Date Range:</Form.Label>
              <DatePicker
                selectsRange={true}
                startDate={startDate}
                endDate={endDate}
                onChange={(update) => {
                  setDateRange(update);
                  console.log(update);
                }}
                isClearable={true}
                placeholder="Enter date range..."
              />
            </Col>
            <Col className="mb-2" lg={6} md={6} sm={12}>
            <Form.Label>Paper Name:</Form.Label>
              <Select value={selectPaper} onChange={onPaperSelect}>
                <option value="" disabled>
                  Select Paper Name
                </option>
                {paperData.map((item, i) => {
                  return (
                    <option
                      value={[item.paper_id, i]}
                      key={uid(item)}
                    >{`(${item.paper_id}) - ${item.paper_name} (${item.to_be_held_on})`}</option>
                  );
                })}
              </Select>
            </Col>
            <Col className="mb-2" lg={6} md={6} sm={12}>
            <Form.Label>My Assign Section:</Form.Label>
              <Select value={selectMyAssign} onChange={e => setSelectMyAssign(e.target.value)}>
                <option value="" disabled>
                  Select My Assign Section
                </option>
                {myAssignData[0] && Object.values(myAssignData[1])
                .map((data) => {
                    return (
                      <option value={data.sec_id} key={uid(data)}>
                        {data.section_name}
                      </option>
                    );
                  })}
              </Select>
            </Col>
            <Col className="mb-2" lg={6} md={6} sm={12}>
            <Form.Label>Copy paper section:</Form.Label>
              <Select value={reqData.sec_id} onChange={e => {
                setReqData(prev => {
                  return {
                    ...prev,
                    sec_id:e.target.value
                  }
                })
              }}>
                <option value="" disabled>
                  Select Copy Paper Section
                </option>
                {facultyList.map(item => {
                  return <option value={item.sec_id} key={uid(item)}>{item["TblSection.section_name"]}</option>
                })}
              </Select>
            </Col>
            <Col className="" lg={6} md={6} sm={12}>
            <Form.Label>Faculty:</Form.Label>
              <Select value={selectedfaculty} onChange={e => {
                const splitedArr = e.target.value.split(',')
                 setSelectedFaculty(e.target.value)
                 console.log('datas',splitedArr[0],splitedArr[1])
                setReqData(prev => {
                  return {
                    ...prev,
                    faculty_id:splitedArr[0],
                    question:splitedArr[1],
                  }
                })
              }}>
                <option value="" disabled>
                  {isEmpty(facultyList)
                    ? "No data available"
                    : "Select Faculty Name"}
                </option>
                {!isEmpty(facultyList) &&
                  [
                    ...new Map(
                      facultyList.map((item) => [item["user_id"], item])
                    ).values(),
                  ].map((item) => {
                    return (
                      <option value={[item.user_id,item.question]} key={uid(item)}>
                        {item["userid.name"]}
                      </option>
                    );
                  })}
              </Select>
            </Col>
            {!isEmpty(qidList) && (
              <Col lg={6} md={6} sm={12} className='mb-4'>
              <Form.Label>QID's:</Form.Label>
                  {/* <Form.Label htmlFor="Class">Class :</Form.Label> */}
                  <MultiSelectDropdown
                    placeholder="Select Questions"
                    selectionLimit={reqData.question}
                    options={qidList}
                    displayValue="TblPaper.qid"
                    onSelect={(selectedList, selectedItem) => {
                      setSelectedQid(prev => {
                        return [
                          ...selectedList
                        ]
                      })
                      console.log(selectedList)
                    }
                    }
                    onRemove={(selectedList, selectedItem) => {
                      setSelectedQid(prev => {
                        return [...selectedList]
                      })
                      console.log(selectedList)
                    }
                    }
                  />
                </Col>
            )}
            {/*  */}
            {/*  */}
            {!isEmpty(selectedQid) && (
              <>
              <Col lg={12} md={12} sm={12}>
              <h5 className="mb-3">Sequence of subjects:</h5>
              <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="droppableQid">
                  {(provided) => (
                    <div
                    style={{height: 47*(selectedQid.length+1)+"px"}}
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                    >
                      {selectedQid.map((item, index) => (
                        <Draggable
                          key={JSON.stringify(item)}
                          draggableId={JSON.stringify(item)}
                          index={index}
                        >
                          {(provided, snapshot) => (
                            <div
                              className={`d-flex gap-4 align-items-center border px-2 ${classes.dragItem}`}
                              ref={provided.innerRef}
                              snapshot={snapshot}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                            >
                              <i className="fa-solid fa-grip-vertical"></i>
                              <div>{index+1}. {item['TblPaper.qid']}</div>
                            </div>
                          )}
                        </Draggable>
                      ))}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
              </Col>
              <Col lg={12} md={12} sm={12} className='text-center'>
                <SecBTN className='sec-btn1' onClick={createDummyPaper}>Create</SecBTN>
              </Col>
              </>
            )
            }
          </Row>
        </Card>
      </div>
    </>
  );
}

export default CreateDummy